import {getJson, readOptionLabels} from "./exercisePickerShared";
import {bindNativeModalCancel, setNativeModalOpen} from "./modalShared";

function clearNode(node) {
    while (node.firstChild) {
        node.removeChild(node.firstChild);
    }
}

function createTextElement(tagName, className, text) {
    const element = document.createElement(tagName);
    if (className) {
        element.className = className;
    }
    element.textContent = text;
    return element;
}

function createTagGroup(label, value) {
    const control = document.createElement("div");
    control.className = "control";

    const tags = document.createElement("div");
    tags.className = "tags has-addons";
    tags.appendChild(createTextElement("span", "tag", label));
    tags.appendChild(createTextElement("span", "tag is-primary", value));

    control.appendChild(tags);
    return control;
}

function createPicture(exercise, imageUrl, sequenceIndex) {
    const picture = document.createElement("picture");
    picture.className = "image is-square";

    const desktopAvif = document.createElement("source");
    desktopAvif.media = "(min-width: 769px)";
    desktopAvif.type = "image/avif";
    desktopAvif.srcset = imageUrl.replace("800.jpg", "800.avif");
    picture.appendChild(desktopAvif);

    const mobileAvif = document.createElement("source");
    mobileAvif.type = "image/avif";
    mobileAvif.srcset = imageUrl.replace("800.jpg", "400.avif");
    picture.appendChild(mobileAvif);

    const desktopJpg = document.createElement("source");
    desktopJpg.media = "(min-width: 769px)";
    desktopJpg.srcset = imageUrl.replace("800.jpg", "800.jpg");
    picture.appendChild(desktopJpg);

    const image = document.createElement("img");
    image.loading = "lazy";
    image.src = imageUrl.replace("800.jpg", "400.jpg");
    image.alt = (exercise.name || "") + " - Image " + (sequenceIndex + 1);
    picture.appendChild(image);

    return picture;
}

export function createHowToModal(options) {
    options = options || {};

    const root = typeof options.root === "string" ? document.querySelector(options.root) : options.root;
    if (!root) {
        return null;
    }

    const body = root.querySelector("[data-howto-modal-body]");
    const loadingBody = root.querySelector("[data-howto-modal-loading]");
    const closeNodes = root.querySelectorAll("[data-howto-modal-close]");
    const bodypartLabels = readOptionLabels(document.querySelector("[data-exercise-modal-bodypart]"));
    const categoryLabels = readOptionLabels(document.querySelector("[data-exercise-modal-category]"));
    const cache = {};
    let loadingExerciseId = null;

    function renderExercise(exercise) {
        if (!body) {
            return;
        }

        clearNode(body);
        body.appendChild(createTextElement("h3", "title is-4 is-size-5-mobile mb-3", exercise.name || ""));

        const tags = document.createElement("div");
        tags.className = "field is-grouped is-grouped-multiline mb-1";
        tags.appendChild(createTagGroup(root.dataset.bodypartLabel || "Body Part", bodypartLabels[exercise.bodypart] || exercise.bodypart || ""));
        tags.appendChild(createTagGroup(root.dataset.categoryLabel || "Category", categoryLabels[exercise.category] || exercise.category || ""));
        body.appendChild(tags);

        const columns = document.createElement("div");
        columns.className = "columns is-mobile is-multiline";
        const images = Array.isArray(exercise.images) ? exercise.images : [];
        for (let i = 0; i < images.length; i++) {
            const column = document.createElement("div");
            column.className = "column is-half";
            column.appendChild(createTextElement("h3", "subtitle is-5 mb-1", String(i + 1)));
            column.appendChild(createPicture(exercise, images[i], i));
            columns.appendChild(column);
        }
        body.appendChild(columns);
    }

    function showLoading() {
        if (body) {
            body.classList.add("is-hidden");
        }
        if (loadingBody) {
            loadingBody.classList.remove("is-hidden");
        }
    }

    function showBody() {
        if (loadingBody) {
            loadingBody.classList.add("is-hidden");
        }
        if (body) {
            body.classList.remove("is-hidden");
        }
    }

    function loadExercise(exerciseId) {
        if (cache[exerciseId]) {
            loadingExerciseId = null;
            renderExercise(cache[exerciseId]);
            showBody();
            return;
        }

        loadingExerciseId = exerciseId;
        showLoading();

        getJson("exercises/" + exerciseId, {
            "exercise.fields": "category,name_url,bodypart,images",
            lang: window.vuelang || "en",
        }).then(function (response) {
            if (loadingExerciseId !== exerciseId) {
                return;
            }
            cache[exerciseId] = response.data;
            renderExercise(response.data || {});
            showBody();
        }).catch(function () {
            if (loadingExerciseId === exerciseId) {
                hideModal();
            }
        });
    }

    function onKeyDown(event) {
        if (event.key === "Escape") {
            hideModal();
        }
    }

    function showModal(exerciseId) {
        if (!exerciseId) {
            return;
        }
        setNativeModalOpen(root, true);
        document.addEventListener("keydown", onKeyDown);
        loadExercise(String(exerciseId));
    }

    function hideModal() {
        loadingExerciseId = null;
        document.removeEventListener("keydown", onKeyDown);
        setNativeModalOpen(root, false);
    }

    for (let i = 0; i < closeNodes.length; i++) {
        closeNodes[i].addEventListener("click", hideModal);
    }

    bindNativeModalCancel(root, hideModal);

    return {
        showModal: showModal,
        hideModal: hideModal,
    };
}
